export const Title = ({ text }: { text: string }) => {
  return <h2 className="text-light-text text-base font-bold">{text}</h2>;
};
